const defaultUrl = 'https://images.delfi.lt/media-api-image-cropper/v1';
const defaultExtension = 'jpg';

type BuildPictureUrlArguments = { url?: string; id: string; extension?: string; aspectRatio?: number; isThumbnail: boolean };

export default function buildPictureUrl({
  id,
  url = defaultUrl,
  extension = defaultExtension,
  aspectRatio = 1.5,
  isThumbnail = false,
}: BuildPictureUrlArguments) {
  let width, height, position;

  width = 1287;
  height = 858;

  if (aspectRatio < 1) {
    width = 858;
    height = 1287;
  }

  if (isThumbnail) {
    width = 240;
    height = 160;

    if (aspectRatio < 1) {
      position = '&cy=0';
    }
  }

  return `${url}/${id}.${extension}?noup&w=${width}&h=${height}${position}`;
}
